"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExperimentTreatments;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var initialState = {
  isLoading: false,
  hasErrors: false,
  treatments: []
};

function ExperimentTreatments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;

  switch (type) {
    case _ActionTypes.EXPERIMENT_TREATMENTS_REQUESTED:
      return Object.assign({}, state, {
        isLoading: true
      });

    case _ActionTypes.EXPERIMENT_TREATMENTS_RECEIVED:
      return {
        isLoading: false,
        hasErrors: false,
        treatments: payload.treatments
      };

    case _ActionTypes.EXPERIMENT_TREATMENTS_FAILED:
      if (error) {
        console.error(error);
      }

      return {
        isLoading: false,
        hasErrors: true
      };

    default:
      return state;
  }
}

module.exports = exports.default;